import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-external-layout',
  templateUrl: './external-layout.component.html',
    styles: [],
    standalone: false
})
export class ExternalLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
